import { DarkMode, LightMode } from "@mui/icons-material";
import type { primaryThemeColors } from "../themes/primaryTheme/primaryThemeColors";
import type { primaryThemeFonts } from "../themes/primaryTheme/primaryThemeFonts";
import type { secondaryThemeColors } from "../themes/secondaryTheme/secondaryThemeColors";
import type { primaryThemeBreakpoints } from "../themes/primaryTheme/primaryThemeBreakpoints";

export const DARK_THEME = "dark";
export const LIGHT_THEME = "light";

export interface Theme {
  colors: typeof primaryThemeColors | typeof secondaryThemeColors;
  font: typeof primaryThemeFonts;
  breakpoints: typeof primaryThemeBreakpoints;
  //typography: object;
}

export const themes = [
  {
    name: LIGHT_THEME,
    icon: <LightMode />,
  },
  {
    name: DARK_THEME,
    icon: <DarkMode />,
  },
];

export const getNextTheme = (currentTheme: string) => {
  const currentThemeIndex =
    themes?.findIndex?.((singleTheme) => singleTheme?.name === currentTheme) ||
    0;
  const nextThemeIndex =
    currentThemeIndex === themes?.length - 1 ? 0 : currentThemeIndex + 1;
  return themes[nextThemeIndex]?.name;
};

export const themeStorageKey = "colorMode";
